module.exports = __webpack_public_path__ + "static/actu-a28dab526d5a4ac8f46fb97a091d6151.jpg";